import { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { bindActionCreators, Dispatch } from 'redux';
import { setToken } from 'services/users';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { RootState } from 'types';
import { withRouter } from 'utils/withRouter';

interface UserProps {
    params?: {
        tab?: string;
        token?: string;
        uuid?: string;
    };
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface UserState {
    user: Record<string, unknown>;
}

class User extends Component<UserProps, UserState> {
    constructor(props: UserProps) {
        super(props);
        this.state = {
            user: {},
        };
    }

    componentDidMount() {
        if (this.props?.params?.tab === undefined) {
            window.location.href = '/home';
            return;
        }
        if (this.props?.params.tab === 'setToken') {
            setToken({
                token: this.props.params.token!,
                uuid: this.props.params.uuid!,
            })
                .then(async (res: any) => {
                    res.user.user_ports = res.user.user_ports.map((x: any) => {
                        if (typeof x.port.meta_data === 'string') {
                            try {
                                x.port.meta_data = JSON.parse(x.port.meta_data.replace(/'/g, '"'));
                            } catch (error) {
                                console.error(error);
                            }
                        }
                        return x;
                    });
                    localStorage.setItem('user', JSON.stringify(res.user));
                    localStorage.setItem('token', res?.token || this.props?.params?.token );
                    localStorage.setItem('uuid', this.props?.params?.uuid || '');
                    localStorage.setItem('apikey', res.apikey || '');

                    // User has no ports
                    if (!res.user.user_ports || res.user.user_ports.length === 0) {
                        window.location.href = '/user/notAssigned';
                    } else {
                        setTimeout(() => {
                            window.location.href = '/user/selectPort';
                        }, 200);
                    }
                })
                .catch((error: any) => {
                    this.props.setErrorHandlerAction(error);
                });
        }
    }

    render() {
        return (
            <Fragment>
                {this.props?.params?.tab ? (
                    <section className="items-center justify-center  right-0 top-0 flex fixed w-full h-full z-20 bg-white overflow-hidden">
                        {this.props.params.tab === 'codeError' ? (
                            <img src="/static/images/application-security.png" className="mx-auto" alt="Code Error" />
                        ) : null}
                        {this.props.params.tab === 'notuser' || this.props.params.tab === 'notAssigned' ? (
                            <img src="/static/images/application-403.png" className="mx-auto" alt="Not Authorized" />
                        ) : null}
                        {this.props.params.tab === 'setToken' ? <LoaderSpinner variant="page"></LoaderSpinner> : null}
                    </section>
                ) : null}
            </Fragment>
        );
    }
}

const UserStateToProps = (state: RootState) => ({});

const UserDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(UserStateToProps, UserDispatchToProps)(withRouter(User));
